import React, { useEffect, MouseEvent, useState, ChangeEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, InputBase, TextField } from '@mui/material';
import { styled } from '@mui/system';
import { debounce } from 'lodash';
import posthog from 'posthog-js';

import './scss/index.scss';
import './scss/report-modal.scss';
import Color from '@/tool/color';
import moVip, {
  vipInit, changeApply, toApplication, changeRemark,
} from './store/index';
import AppLogin from '@con/app-login';
import Header from '@comp/header/index';
import Footer from '@comp/footer/index';
import VipMeal from './component/vip-meal';
import VipDetail from './component/vip-detail';
import VipService from './component/vip-service';
import VipCustomer from './component/vip-customer';
import { getBaseInfo } from '@store/user';
import AppLoading from '@con/app-loading';
import AppCover from '@con/app-cover';
import AppAlert from '@con/app-alert';
import LoginCover from '@con/login-cover';
import moStore, { toggleValue } from '@store/index';
import { PosthogApiKey, PosthogApiHost } from '@/config';
import moSkin from '@store/skin';
import HRootVip from './component/hroot-vip';
import ConfigVip from './component/config-vip';
import SingleVideo from '@comp/video-play/single-video';
import moHome from '@store/home';

interface IProps { }
interface IState { }

const DButton = styled(Button)(() => ({
  width: '200px',
  height: '40px',
  borderRadius: '20px',
  border: `1px solid ${Color.ec}`,
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: 1,
  color: `${Color.fff}`,
}));

const KButton = styled(Button)(() => ({
  width: '120px',
  height: '36px',
  borderRadius: '18px',
  fontSize: '14px',
  lineHeight: 1,
  fontWeight: 500,
}));

const AButton = styled(KButton)(() => ({
  border: `1px solid ${Color.d9}`,
  color: Color.c333,
}));

const CButton = styled(KButton)(() => ({
  marginLeft: '20px',
  color: Color.fff,
  backgroundColor: Color.secondary,
}));

const EInput = styled(InputBase)(() => ({
  width: '100%',
  height: '80px',
  marginTop: '20px',
  padding: '10px',
  borderRadius: '2px',
  border: `1px solid ${Color.d9}`,
}));

const Vip = (props: IProps, state: IState) => {
  const location = useLocation();
  const navi = useNavigate();
  const { videoUrl, isOpen } = moHome;
  const [isOpacity, setOpacity] = useState(true);
  const {
    isApply, remark, isAlert, alertText,
    text1, text2, text3,
  } = moVip;
  const { loginModal } = moStore;
  const [winWidth, setWinWidth] = useState(0);
  const { partner, counselor, titleCapColor } = moSkin;

  const onScroll = () => {
    if (window.scrollY > 60) setOpacity(false);
    else setOpacity(true);
  };

  const onResize = () => {
    const width = document.body.clientWidth || document.documentElement.clientWidth;
    setWinWidth(width);
  };
  useEffect(() => {
    document.title = "企业套餐"
  })
  useEffect(() => {
    toggleValue('isLoading', true);
    onScroll();
    onResize();
    window.addEventListener('scroll', debounce(onScroll, 200));
    window.addEventListener('resize', onResize);

    // console.log('--- posthog api key --- ', PosthogApiKey);
    // console.log('--- posthog api host --- ', PosthogApiHost);
    // posthog.init(PosthogApiKey, {
    //   api_host: PosthogApiHost,
    //   persistence: 'localStorage+cookie',
    //   autocapture: true,
    // });
    posthog.capture('进入企业套餐页面', {});
    getBaseInfo(vipInit);

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, [partner]);

  const cancelCommit = () => {
    changeApply(false);
  };

  const onCommit = () => {
    posthog.capture('首页-开通企业会员', {});
    changeApply(false);
    toApplication(remark);
  };

  // 联系薪酬专家
  const onContact = () => {
    const btn = document.getElementById('nb_invite_ok');
    if (btn) { btn.click(); }
  };

  const changeText = (ev: ChangeEvent<HTMLInputElement>) => {
    ev.stopPropagation();
    changeRemark(ev.target.value);
  };

  return (
    <section className="vip-page">
      <Header isOpacity={isOpacity} />

      <section className="vip-container">
        {/* banner */}
        <section className="vip-banner">
          <section className="banner-10">
            <section className="section-11">
              <p className="p-11">企业VIP套餐</p>
              <p className="p-12">
                <span>服务内容全新升级 享受更多平台特权；</span>
                <span>专属薪酬专家顾问1V1解读企业薪酬现状，对标市场给予分析指导；</span>
                <span>赋能课程助力HR决策转型！</span>
              </p>
            </section>
            {partner === 'smartsalary' ? (
              <section className="section-12">
                <DButton onClick={onContact}>联系薪酬专家</DButton>
                <p className="p-20">或拨打：400-101-9070联系我们</p>
              </section>
            ) : (
              <p className="line-15051">
                联系我们: {counselor?.phoneNum}
              </p>
            )}
          </section>
        </section>

        {/* 套餐 */}
        <section className="vip-meal">
          <section className="meal-container"
            style={{
              padding: winWidth > 1360 ? '0 80px 100px 80px' : '0 20px 100px 20px',
            }}>
            {/* 套餐 - 多种服务选择 */}
            <section className="meal-section meal-10">
              <section className="meal-head">
                <p className="line-91 title-101">多种服务选择</p>
                <p className="line-91 p-102">针对不同场景、企业决策需求、选择不同产品服务</p>
              </section>
              <VipMeal />
            </section>

            {/* 套餐 - 为什么要开通企业套餐服务？ */}
            <section className="meal-section meal-11">
              <section className="meal-head">
                <p className="title-101">为什么要开通企业套餐服务？</p>
                <p className="p-102">及时掌控企业运营风险 了解人才流动走向 洞察薪酬福利趋势 打造差异化专业薪酬体系</p>
              </section>
              <VipService />
            </section>

            {/* 套餐 - 企业套餐权益详细说明 */}
            {/* <section className="meal-section meal-12">
                <section className="meal-head">
                  <p className="title-101">企业套餐权益详细说明</p>
                </section>
                <VipDetail />
              </section> */}
          </section>
        </section>

        {partner === 'smartsalary' ? (
          <section className="customer-50">
            <section className="customer-content">
              <p className="temp-10"></p>
              <section className="meal-head">
                <p className="title-101">听听企业客户怎么说</p>
              </section>
              <VipCustomer />
            </section>
          </section>
        ) : null}
      </section>

      {isApply ? (
        <AppCover>
          <section className="report-modal">
            <section className="one-050">
              <p className="one-051">
                <b>{text1}</b>
              </p>
              <span className="span-006">{text2}</span>
              <span className="span-007">{text3}</span>
              <EInput value={remark} multiline={true} rows={3}
                onChange={(ev: ChangeEvent<HTMLInputElement>) => changeText(ev)}
                placeholder="请填写备注信息" />
            </section>
            <p className="one-055">
              <AButton onClick={cancelCommit}>取消</AButton>
              <CButton variant="contained" color="secondary"
                onClick={onCommit}>提交
              </CButton>
            </p>
          </section>
        </AppCover>
      ) : null}

      {isAlert ? <AppAlert text={alertText} /> : null}
      {loginModal ? <LoginCover /> : null}
      <Footer />
      <AppLoading />
      <AppLogin />
      <SingleVideo videoUrl={videoUrl} isOpen={isOpen} />
    </section>
  );
};

export default observer(Vip);
